import $script from 'scriptjs';
import axios from 'axios';
import Cookies from 'js-cookie';
import { triggerCustomEvent } from 'lib/helpers';
import {
  fromSignup,
  removeSocialOauthCookie,
  showSignupSurvey,
  socialSessionLoading,
  socialSessionError,
  socialSessionFromFollow,
} from 'lib/social-session-helpers';
import {
  findReferringCategory,
  trackCompleteEvent,
} from 'components/analytics/conversions/tracking';
import { JOIN_COMPLETE, LOGIN_COMPLETE } from 'components/analytics/conversions/constants/actions';

export default class GoogleLogin {
  constructor({
    buttonTarget, textTarget = null, csrfToken, omniauthToken,
  }) {
    this.buttonTarget = buttonTarget;
    this.textTarget = textTarget;
    this.csrfToken = csrfToken;
    this.omniauthToken = omniauthToken;
    this.handleGoogleResponse = this.handleGoogleResponse.bind(this);
    this.handleError = this.handleError.bind(this);
    this.init();
  }

  init() {
    socialSessionError(false, this.buttonTarget);

    $script('https://apis.google.com/js/platform.js', this.loadGoogleApi);
  }

  loadGoogleApi = () => {
    window.gapi.load('auth2');
    this.buttonTarget.dataset.loaded = 'true';
  }

  connect() {
    if (this.textTarget) {
      this.originalText = this.textTarget.innerHTML;

      socialSessionLoading(this.buttonTarget);
    }

    socialSessionError(false, this.buttonTarget);

    this.login();
  }

  login() {
    window.gapi.auth2.authorize({
      client_id: this.buttonTarget.dataset.appId,
      cookie_policy: 'single_host_origin',
      scope: 'email profile',
      response_type: 'code',
    }, this.handleGoogleResponse);
  }

  handleGoogleResponse(response) {
    if (response && !response.error) {
      // google authentication succeed, now post data to server.
      const newsletter = document.getElementById('user_newsletter');
      let newsletterValue = false;
      if (newsletter !== null && newsletter.type !== 'hidden') {
        newsletterValue = newsletter.checked;
      } else if (newsletter !== null && newsletter.type === 'hidden') {
        newsletterValue = true;
      }

      axios.defaults.headers.common['X-CSRF-Token'] = this.csrfToken;
      axios.post(`/users/auth/google_oauth2/callback?state=${this.omniauthToken}&newsletter=${newsletterValue}`, response)
        .then(this.responseSuccess)
        .catch(this.handleError);
    } else { this.handleError(response?.error); }
  }

  responseSuccess = (response) => {
    if (response.status === 200 || response.status === 204) {
      this.processResponse(response);
    } else { this.handleError(response.error); }

    removeSocialOauthCookie();
  }

  processResponse(response) {
    // using the social_oauth_type cookie to check if it's javascript
    if (fromSignup()) {
      // we have to eval the modal injector code coming back
      if (showSignupSurvey(response)) eval(response.data); // eslint-disable-line no-eval

      trackCompleteEvent({
        action: JOIN_COMPLETE,
        category: findReferringCategory(this.buttonTarget),
        label: 'Sign_Up-Google',
        dataLayerCompleteAttrs: [
          'email_address',
          'email_hash_md5',
          'email_hash_sha1',
          'sign_in_type',
        ],
      });

      return; // the rest of the function is for logins
    }

    trackCompleteEvent({
      action: LOGIN_COMPLETE,
      category: findReferringCategory(this.buttonTarget),
      label: 'Sign_In-Google',
      dataLayerCompleteAttrs: [
        'email_address',
        'email_hash_md5',
        'email_hash_sha1',
        'sign_in_type',
        'name',
        'country',
        'postal_code',
        'team_owner_email',
        'team_seats',
        'multiple_logins',
      ],
    });

    if (this.fromFollow) {
      window.location.reload();
    } else if (response.data.message === 'login_in_place') {
      triggerCustomEvent('LoggedInPlace');
    } else if (Cookies.get('sign_in_referrer')) {
      window.location.assign(Cookies.get('sign_in_referrer'));
    } else {
      window.location.reload();
    }
  }

  get fromFollow() {
    return socialSessionFromFollow();
  }

  handleError = (error) => {
    if (error) console.error(error); // eslint-disable-line no-console
    if (this.textTarget) socialSessionLoading(this.buttonTarget, this.originalText);
    socialSessionError(true, this.buttonTarget);
  }
}
